export const getForeName = () => {
  const SESSION_DATA = sessionStorage.getItem("userSession");
  const USER_SESSION = JSON.parse(SESSION_DATA);
  return USER_SESSION?.forename.toLowerCase() || "User";
};

export const getUserIndicator = () => {
  const session = sessionStorage.getItem("userSession");
  return session ? JSON.parse(session)?.clientLandingPageIndicator : undefined;
};

export const getCustomerObjectId = () => {
  const session = sessionStorage.getItem("userSession");
  return session ? JSON.parse(session)?.customerObjectId : undefined;
};

export const getSalesforceContactId = () => {
  if (
    typeof window === "undefined" ||
    typeof window.sessionStorage === "undefined"
  ) {
    return undefined;
  }
  const session = sessionStorage.getItem("userSession");
  return session ? JSON.parse(session)?.salesforceContactId : undefined;
};
